export default __webpack_public_path__ + "static/media/kube_icon.b6b3df85.png";